import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Button, Checkbox, Group, Modal, Stack } from '@mantine/core';

import showToast from 'actions/toastActions';
import { DispatchType } from 'store/dispatch/types';
import { dismissAlert, snoozeAlert } from 'store/samplePlans/requests';

type ManageAlertsPropsType = {
  samplePlan: DispatchType;
  onSubmit: VoidFunction;
  onClose: VoidFunction;
  opened: boolean;
  snooze: boolean;
};

export const ManageAlerts = ({
  samplePlan,
  onSubmit,
  onClose,
  opened,
  snooze,
}: ManageAlertsPropsType) => {
  const { t } = useTranslation();

  const [alertIds, setAlertIds] = useState<number[]>([]);

  const addAlert = (id: number) => {
    setAlertIds([...alertIds, id]);
  };

  const removeAlert = (id: number) => {
    setAlertIds(alertIds.filter((a) => a !== id));
  };

  const updateAlert = async () => {
    try {
      await Promise.all(
        alertIds.map(async (id) => {
          if (snooze) {
            await snoozeAlert(id);
          } else {
            await dismissAlert(id);
          }
        }),
      );
      onSubmit();
    } catch (e: any) {
      showToast(t('updatingAlertError'));
    }
    onClose();
  };

  return (
    <Modal
      onClose={onClose}
      opened={opened}
      title={t(snooze ? 'selectAlertsToSnooze' : 'selectAlertsToDismiss')}
      centered
    >
      <Stack justify="center" align="center" gap="xl" mb="lg">
        <Stack align="flex-end" miw="0">
          {samplePlan.alerts.map((alert) => {
            const checked = alertIds.includes(alert.id);
            return (
              <Group
                key={alert.name}
                justify="flex-start"
                align="center"
                onClick={checked ? () => removeAlert(alert.id) : () => addAlert(alert.id)}
                style={{
                  cursor: 'pointer',
                }}
              >
                <Checkbox checked={checked} labelPosition="left" label={t(alert.name)} />
              </Group>
            );
          })}
        </Stack>
        <Group>
          <Button variant="danger" onClick={onClose}>
            {t('cancel')}
          </Button>
          <Button onClick={updateAlert}>{t('confirm')}</Button>
        </Group>
      </Stack>
    </Modal>
  );
};
